export class Income {
    amount: string;
    edate: string;
  }